import getRequest from '@/api'

const request = getRequest(process.env.VUE_APP_PRICE_API, 'data')

/**
 * 是否显示打样流程
 */
export function isShowProofingProcess() {
  return request.get('accountReminder/selectStatus')
}

/**
 * 设置是否显示打样流程
 */
export function setShowProofingProcess(status) {
  return request.post(`accountReminder/updateStatus/${status}`)
}

/**
 * 获取打样节点列表
 */
export function getProofingNodeList(data) {
  return request.post('node/page', data)
}

/**
 * 添加打样节点
 */
export function addProofingNode(data) {
  return request.post('node', data)
}

/**
 * 修改打样节点
 */
export function modifyProofingNode(data) {
  return request.put('node', data)
}

/**
 * 删除打样节点
 */
export function deleteProofingNode(id) {
  return request.delete(`node/${id}`)
}

/**
 * 获取节点模板列表
 */
export function getNodeTemplateList(data) {
  return request.post('nodeTemplate/page', data)
}

/**
 * 添加节点模板
 */
export function addNodeTemplate(data) {
  return request.post('nodeTemplate', data)
}

/**
 * 修改节点模板
 */
export function modifyNodeTemplate(data) {
  return request.put('nodeTemplate', data)
}

/**
 * 删除节点模板
 */
export function deleteNodeTemplate(id) {
  return request.delete(`nodeTemplate/${id}`)
}

/**
 * 获取节点模板关系列表
 */
export function getNodeTemplateRelationList(data) {
  return request.post('nodeTemplateRelation/query', data)
}

/**
 * 添加节点模板关系
 */
export function addNodeTemplateRelation(data) {
  return request.post('nodeTemplateRelation', data)
}

/**
 * 修改节点模板关系
 */
export function modifyNodeTemplateRelation(data) {
  return request.put('nodeTemplateRelation', data)
}

/**
 * 删除节点模板关系
 */
export function deleteNodeTemplateRelation(id) {
  return request.delete(`nodeTemplateRelation/${id}`)
}

/**
 * 获取版单类型列表
 */
export function getEditionTypeList(data) {
  return request.post('versionType/page', data)
}

/**
 * 添加版单类型
 */
export function addEditionType(data) {
  return request.post('versionType', data)
}

/**
 * 修改版单类型
 */
export function modifyEditionType(data) {
  return request.put('versionType', data)
}

/**
 * 删除版单类型
 */
export function deleteEditionType(id) {
  return request.delete(`versionType/${id}`)
}

/**
 * 获取打样单列表
 */
export function getProofingOrderList(data) {
  return request.post('order/page', data)
}

/**
 * 获取打样单详情
 */
export function getProofingOrderDetail(id) {
  return request.get(`order/${id}`)
}

/**
 * 引用打样单
 */
export function copyProofingOrder(id) {
  return request.get(`order/copy/${id}`)
}

/**
 * 添加打样单
 */
export function addProofingOrder(data) {
  return request.post('order', data)
}

/**
 * 修改打样单
 */
export function modifyProofingOrder(data) {
  return request.put('order', data)
}

/**
 * 修改打样单状态
 */
export function modifyProofingOrderStatus(data) {
  return request.post('order/updateStatus', data)
}

/**
 * 删除打样单
 */
export function deleteProofingOrder(id) {
  return request.delete(`order/${id}`)
}

/**
 * 获取打样分类列表
 */
export function getProofingClassifyList(data) {
  return request.post('category/tree', data)
}

/**
 * 获取打样分类列表
 */
export function getProofingUserList(data) {
  return request.post('account/list', data)
}

/**
 * 获取打样颜色列表
 */
export function getProofingColorList(data) {
  return request.post('orderColor/query', data)
}

/**
 * 添加打样颜色
 */
export function addProofingColor(data) {
  return request.post('orderColor/batchSave', data)
}

/**
 * 修改打样颜色
 */
export function modifyProofingColor(data) {
  return request.put('orderColor', data)
}

/**
 * 删除打样颜色
 */
export function deleteProofingColor(id) {
  return request.delete(`orderColor/${id}`)
}

/**
 * 获取打样尺码列表
 */
export function getProofingSizeList(data) {
  return request.post('orderSize/query', data)
}

/**
 * 添加打样尺码
 */
export function addProofingSize(data) {
  return request.post('orderSize/batchSave', data)
}

/**
 * 修改打样尺码
 */
export function modifyProofingSize(data) {
  return request.put('orderSize', data)
}

/**
 * 删除打样尺码
 */
export function deleteProofingSize(id) {
  return request.delete(`orderSize/${id}`)
}

/**
 * 获取打样颜色尺码数量列表
 */
export function getProofingColorSizeCount(data) {
  return request.post('orderColorSize/query', data)
}

/**
 * 保存打样颜色尺码数量
 */
export function saveProofingColorSizeCount(orderId, data) {
  return request.post(`orderColorSize/${orderId}/batchSaveUpdate`, data)
}

/**
 * 获取物料列表
 */
export function getProofingAddMaterialList(data) {
  return request.post('wms/selectPage', data)
}

/**
 * 获取打样物料列表
 */
export function getProofingMaterialList(data) {
  return request.post('orderMaterial/query', data)
}

/**
 * 保存打样物料
 */
export function saveProofingMaterial(orderId, data) {
  return request.post(`orderMaterial/${orderId}/batchSaveUpdate`, data)
}

/**
 * 删除打样物料
 */
export function deleteProofingMaterial(id) {
  return request.delete(`orderMaterial/${id}`)
}

/**
 * 获取工艺要求列表
 */
export function getProofingCraftList(data) {
  return request.post('orderCraft/query', data)
}

/**
 * 添加工艺要求
 */
export function addProofingCraft(data) {
  return request.post('orderCraft', data)
}

/**
 * 修改工艺要求
 */
export function modifyProofingCraft(data) {
  return request.put('orderCraft', data)
}

/**
 * 删除工艺要求
 */
export function deleteProofingCraft(id) {
  return request.delete(`orderCraft/${id}`)
}

/**
 * 获取打样尺寸列表
 */
export function getProofingPositionSizeList(data) {
  return request.post('orderMeasurePosition/query', data)
}

/**
 * 保存打样尺寸
 */
export function saveProofingPositionSize(orderId, data) {
  return request.post(`orderMeasurePosition/${orderId}/batchSaveUpdate`, data)
}

/**
 * 删除打样尺寸
 */
export function deleteProofingPositionSize(id) {
  return request.delete(`orderMeasurePosition/${id}`)
}

/**
 * 获取附件列表
 */
export function getProofingAnnexList(data) {
  return request.post('orderAttachment/query', data)
}

/**
 * 添加附件
 */
export function addProofingAnnex(data) {
  return request.post('orderAttachment', data)
}

/**
 * 修改附件
 */
export function modifyProofingAnnex(data) {
  return request.put('orderAttachment', data)
}

/**
 * 删除附件
 */
export function deleteProofingAnnex(id) {
  return request.delete(`orderAttachment/${id}`)
}

/**
 * 获取意见列表
 */
export function getProofingOpinionsList(data) {
  return request.post('orderOpinion/query', data)
}

/**
 * 添加意见
 */
export function addProofingOpinions(data) {
  return request.post('orderOpinion', data)
}

/**
 * 打样单节点完成数量
 */
export function modifyProofingCount(data) {
  return request.put('orderNode', data)
}
